// src/pages/Appli/AppliAdmin/ListingClients/charts/AssociationsAnalytics.jsx

import React from "react";

import {
  FaChartPie,
  FaCubes,
  FaMedal,
} from "react-icons/fa";

import AssosByDisciplineBar from "./AssosByDisciplineBar";
import AssosByProduitBar from "./AssosByProduitBar";
import AssosByStatutDonut from "./AssosByStatutDonut";

function AnalyticsCard({
  title,
  description,
  icon: Icon,
  children,
}) {
  return (
    <article className="rounded-2xl border border-slate-200 bg-white p-4 shadow-sm dark:border-slate-800 dark:bg-slate-900 sm:p-5">
      <div className="mb-4 flex items-start gap-3">
        <div className="flex h-10 w-10 shrink-0 items-center justify-center rounded-xl bg-violet-100 text-violet-600 dark:bg-violet-500/15 dark:text-violet-300">
          <Icon />
        </div>

        <div>
          <h3 className="font-semibold text-slate-900 dark:text-white">
            {title}
          </h3>

          <p className="mt-0.5 text-xs text-slate-500 dark:text-slate-400">
            {description}
          </p>
        </div>
      </div>

      {children}
    </article>
  );
}

export default function AssociationsAnalytics({
  data = [],
}) {
  return (
    <section className="grid grid-cols-1 gap-5 xl:grid-cols-3">
      <AnalyticsCard
        title="Parcours commercial"
        description="Répartition selon le statut actuel."
        icon={FaChartPie}
      >
        <AssosByStatutDonut data={data} />
      </AnalyticsCard>

      <AnalyticsCard
        title="Produits MonAppliClub"
        description="Produits les plus représentés."
        icon={FaCubes}
      >
        <AssosByProduitBar data={data} />
      </AnalyticsCard>

      <AnalyticsCard
        title="Disciplines sportives"
        description="Disciplines présentes dans les dossiers."
        icon={FaMedal}
      >
        <AssosByDisciplineBar data={data} />
      </AnalyticsCard>
    </section>
  );
}